<template>
  <!-- <div class="deviceinfo"> -->

    


    <b-container >

      <b-row class="text-center">
        <b-col>
            <ToolBar @clickRefresh="DeviceInfo()"/>
        </b-col>

        <b-button-group>

          <b-dropdown variant="light" size="sm" class="mb-0" :text="viewText">
            <b-dropdown-item v-on:click="methodThatForcesUpdate(false)">Grid View</b-dropdown-item>
            <b-dropdown-item v-on:click="methodThatForcesUpdate(true)">Cards View</b-dropdown-item>
          </b-dropdown>

        </b-button-group>    


      </b-row>


      <!-- <b-row class="text-right">

      </b-row>       -->

      <b-row v-if="loading==true">
          <b-col class="text-center">
              <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner" type="grow"></b-spinner>
          </b-col>
      </b-row>    

      <b-row v-if="loading==false">
        <b-col class="text-center">
          <b>{{ deviceName }}</b>
        </b-col>
      </b-row>

      <b-row v-if="loading==false && MobileView==false">
        <b-col>
          
          <ejs-grid  :dataSource="Measurements" :allowPaging="true" :pageSettings='pageSettings'  :allowSorting='true' >
              
              <e-columns>
                <e-column v-for="(Column,index) in Columns" :key="index"
                  :field="Column"
                  textAlign='Left'>
                </e-column>
              </e-columns>

              <!-- <e-columns>
                <e-column field='OrderID' headerText='Order ID' textAlign='Right' width=90></e-column>
                <e-column field='CustomerID' headerText='Customer ID' width=120></e-column>
                <e-column field='Freight' headerText='Freight' textAlign='Right' format='C2' width=90></e-column>
              </e-columns> -->
          </ejs-grid>
        </b-col>
      </b-row>

    <!-- </b-container> -->

      <!-- <b-container > -->


        <!-- <b-card-group deck> -->
      <b-row v-if="loading==false && MobileView==true">
      <b-col>
      

        <b-card class="my-2"
          v-for="(Measurement,index) in response.Measurements" :key="index"
          border-variant="secondary"
          header="Secondary"
          header-border-variant="secondary"
          align="center"
        >        
          <template v-slot:header>
            <h6 class="mb-0">
              {{ Measurement.FetchDate }}
            </h6>
          </template>                  
          
          <b-card-text>
            <div v-for="(Value,index) in Measurement.Values" :key="index">
                  {{Value.Type }} 
                  {{Value.Value}}
                  {{Value.Scale}}              
            </div> 
          </b-card-text>

          <template v-slot:footer>
            <small class="text-muted">{{Measurement.LastUpdate}}</small>
          </template>

        </b-card>

      </b-col>

      </b-row>
        

          
        <!-- </b-card-group> -->


      </b-container>
      
  <!-- </div> -->
</template>


<script>
import axiosService from '@/services/axiosService.js'

import { Page, Sort } from "@syncfusion/ej2-vue-grids";

import ToolBar from '@/components/ToolBar.vue'

// import { BIconArrowUp } from 'bootstrap-vue'


 export default {
    name: 'deviceInfo',
    components: {
        //DeviceInfoC
        ToolBar
        // BIconArrowUp
    },
    props: {
      deviceid: String,
    },        
    data: function () {
        return {
          response : [],
          // data : [],
          Measurements : [],
          Columns : [],
          MobileView: Boolean,
          deviceName: "",
          loading: Boolean,
          pageSettings: { pageSize: 5 }
        }
    },
    provide: {  
    grid: [Page, Sort]
    },        
    methods:{
        DeviceInfo: function () {

             var o =  Object();
             this.loading = true;

            axiosService.getCall(this.$auth, '/v1/Devices/' + this.deviceid )
            .then(response => {
                
                this.response = response.data;

                this.deviceName = response.data.Name;

                this.Columns=[];
                //this.Columns.push('FetchDate');
                this.Columns.push('LastUpdate');


                response.data.Measurements.forEach((value) =>  {

                  o = new Object();

                  value.FetchDate = new Date(value.FetchDate).toLocaleString();
                  
                  //o.FetchDate = value.FetchDate;


                  value.Values.forEach((value2) => {


                    o[value2.Type] = value2.Value + " " + value2.Scale;

                    // Afegim la columna només si no esxisteix
                    if (this.Columns.indexOf(value2.Type) === -1) this.Columns.push(value2.Type);

                    
                  })

                  o.LastUpdate = value.LastUpdate;

                  this.Measurements.push(o)

                  this.loading = false;
                  
                })
                

                console.log(response.data) // For now, logs out the response
                })
                .catch(error => {
                  this.loading=false;
                //this.data = 'There was an error: ' + error.response
                console.log('There was an error: ', error.response) // Logs out the error
                })   
        },
        methodThatForcesUpdate(MobileView) {
          // ...
          if (this.MobileView != MobileView) {
            this.MobileView = MobileView;
            this.$forceUpdate();  // Notice we have to use a $ here
          }
          // ...
        },        
        isMobile() {
            if( screen.width <= 760 ) {
                return true;
            }
            else {
                return false;
            }
        }        
    },        
    computed: {
      viewText: function () {
        if (this.MobileView==true) {
          return "Cards View"
        } else {
          return "Grid View"
        }
      }

    },
    created: async function() {

      this.DeviceInfo()
      this.MobileView=this.isMobile();
         
    }

    // ,
    // watch:{
    //   MobileView: function() {
    //     console.log(this.MobileView);
    //     this.methodThatForcesUpdate();
    //   }
    // }

  }


</script>

<style scoped>
@import '../../node_modules/@syncfusion/ej2-base/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap.css';  
@import '../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap.css';
@import "../../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap.css";
@import '../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-popups/styles/bootstrap.css';
@import "../../node_modules/@syncfusion/ej2-vue-calendars/styles/bootstrap.css";

</style>
